import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/comboboxSelector.scss';
import React from 'react';
import { Background, BorderSize, Foreground, State, Stroke } from '@front/sharedcomponents/Styles';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { SvgIconType } from '../../SvgIcon/SvgIconType';
export const ComboboxSelectorDecorator = React.forwardRef(({ children, onClick, isArrowVisible = true, disabled = false, selected = false, containerClassName }, ref) => {
    const comboboxClassNames = [
        'combobox-selector',
        selected ? Foreground.Primary : Foreground.Secondary,
        selected ? Background.Primary : Background.Secondary,
        Stroke.General,
        BorderSize.Solid1,
        selected ? State.Selected : ''
    ];
    const comboboxClassName = comboboxClassNames.filter(Boolean).join(' ');
    const comboboxContainerClassName = ['combobox-selector-container', containerClassName]
        .filter(Boolean)
        .join(' ');
    const renderArrow = () => {
        if (isArrowVisible) {
            return (_jsx("div", { className: "combobox-selector-arrow", children: _jsx(SvgIcon, { icon: SvgIconType.ArrowDown }) }));
        }
        return null;
    };
    return (_jsx("button", { ref: ref, className: comboboxClassName, disabled: disabled, onClick: onClick, "aria-expanded": selected, "aria-haspopup": "listbox", children: _jsxs("div", { className: comboboxContainerClassName, children: [children, renderArrow()] }) }));
});
